import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card, Table, Button, Row, Col, Container } from 'react-bootstrap'
import { bellIconHollow, expandIcon } from '../../img/font_awesome/font_awesome';
import UserView from '../userView/UserView'
import UserViewEntry from '../userView/UserViewEntry'

const VISIBLE_ROWS = 10; 

const mapStateToProps = (state) => {
    return {
        selectedAlert: state.userViewSelectedAlertReducer
    };
}

const matchDispatchToProps = (dispatch) => {
    return {
        resetSelectedAlert: () => dispatch({ type: 'RESET_SELECTED_ALERT' })
    }
}

class AlertList extends Component {
    state = {
        showUserViewModal: false,
        showEntryModal: false
    }

    handleClick = () => {
        this.setState({
            showUserViewModal: true
        })
    }

    handleOpenAlertEntry = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.setState({
            showUserViewModal: false,
            showEntryModal: true
        })
    }

    handleNewAlertEntry = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.props.resetSelectedAlert();

        this.setState({
            showUserViewModal: false,
            showEntryModal: true
        })
    }


    handleClose = () => {
        this.props.resetSelectedAlert();
        this.setState({
            showUserViewModal: false,
            showEntryModal: false
        })
    }

    render() {

        let alertRows = <div style={{ fontWeight: 'bold' }}>Click on the above "Add New Alert" button to create your very first alert.</div>
        let expandButton = <></>
        let detailsButton = <></>

        if (this.props.myAlerts && this.props.myAlerts.length > 0) {
            let myAlerts = this.props.myAlerts.length > VISIBLE_ROWS ? this.props.myAlerts.slice(0, VISIBLE_ROWS) : this.props.myAlerts;
            let moreThanTen = this.props.myAlerts.length > VISIBLE_ROWS ? true : false;

            alertRows = <Table size='sm'>
                <tbody>
                    <tr>
                        <th className="table-td-xs">Alert</th>
                        <th className="table-td-xs">Criteria</th>
                        <th className="table-td-xs">Status</th>
                    </tr>
                    {
                        myAlerts.map((myAlert, index) => {
                            return <tr key={index}>
                                <td className="table-td-xs">{myAlert.name}</td>
                                <td className="table-td-xs">{myAlert.criteria}</td>
                                <td className="table-td-xs">{myAlert.deliveryMethodStatus}</td>
                            </tr>
                        })
                    }
                    { 
                        moreThanTen &&
                        <tr key={"1" + VISIBLE_ROWS}>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"></td>
                            <td className="table-td-xs"><span className='badge badge-light'>more</span></td>
                        </tr>
                    }
                </tbody>
            </Table>
            expandButton = <span onClick={this.handleClick} style={{ cursor: "pointer", float: 'right' }}>{expandIcon}</span>
            detailsButton = <Button variant="primary" className='btn-sm' onClick={this.handleClick}>Details</Button>
        }

        return (
            <>
                <Card>
                    <Card.Header style={{ backgroundColor: '' }}>
                        {bellIconHollow}&nbsp;&nbsp;My Alerts {expandButton}
                    </Card.Header>
                    <Card.Body>
                        <Container>
                            <Row>
                                <Col style={{ textAlign: 'right' }}><Button onClick={this.handleNewAlertEntry} style={{ fontWeight: 'bold', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.39)" }}>Add New Alert</Button></Col>
                            </Row>
                            <Row>
                                &nbsp;
                            </Row>
                            <Row>
                                <Col>
                                    {alertRows}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                {detailsButton}
                                </Col>
                            </Row>
                        </Container>
                       
                    </Card.Body>
                </Card>
                <UserView key={Date.now()} show={this.state.showUserViewModal} handleClose={this.handleClose} handleNewAlertEntry={this.handleNewAlertEntry} handleOpenAlertEntry={this.handleOpenAlertEntry} />
                <UserViewEntry key={this.props.selectedAlert.id} show={this.state.showEntryModal} handleClose={this.handleClose} alertId={0} />
            </>
        )
    }
}

export default connect(mapStateToProps, matchDispatchToProps)(AlertList);
